<script lang="ts" setup>
import type { Category } from '~~/server/api/menu/footer'

export interface FooterMenuProps {
    categories: Category[]
}

const props = defineProps<FooterMenuProps>()
</script>
<template>
  <div class="row mb-2 mb-md-0">
    <div
      v-for="(section, index) in props.categories"
      :key="`fms-${index}`"
      class="col-12 col-md-4 col-xl-3 mb-2 mb-md-8"
    >
      <FooterMenuSection :section="section" />
    </div>
  </div>
  <IconsWrapper>
    <IconsSymbolAngleDown />
  </IconsWrapper>
</template>

<style lang="scss">
@import './FooterMenu.scss';
</style>
